module.exports = __webpack_public_path__ + "static/media/edit.10779de5.svg";